import { Box, ProgressBar } from '@hausgold/designsystem';
import 'react';
import PropTypes from 'prop-types';
import { jsx } from '@emotion/react';
var ProgressBarCTA = function ProgressBarCTA(_ref) {
  var currentStepIndex = _ref.currentStepIndex,
    totalSteps = _ref.totalSteps;
  var initialValue = 10;
  var fillPercentage = (currentStepIndex + 1) / totalSteps * (100 - initialValue) + initialValue;
  return jsx(Box, {
    width: "100%"
  }, jsx(ProgressBar, {
    value: fillPercentage || initialValue,
    colorScheme: "blue"
  }));
};
ProgressBarCTA.propTypes = {
  currentStepIndex: PropTypes.number,
  totalSteps: PropTypes.number
};
ProgressBarCTA.defaultProps = {
  currentStepIndex: undefined,
  totalSteps: undefined
};
export { ProgressBarCTA as default };